import { Controller } from 'stimulus';
import { None } from 'vega';

export default class extends Controller {
  initialize() {
    $(".spinner-border").hide();
  }
  
  renderStep(event) {
    event.preventDefault();
    let step = $(event.target).data('step');
    let form = $("#airtable_base_form")

    $(event.target).find(".spinner-border").show();
    $(event.target).attr("disabled", true);

    let data = {"step": step}
    data["access_key"] = form.find("input#access_key").val();
    data["base_id"] = form.find("select#base_id").val();
    data["actor_table_id"] = form.find("select#actor_table_id").val();
    data["accounts_table_id"] = form.find("select#accounts_table_id").val();
    data["airtable_base_id"] = form.find("#airtable_base_id").val();

    this.removeFollowingSteps(step)

    console.log(data)

    Rails.ajax({
      type: 'GET',
      url: "render_step",
      data: $.param(data),
      dataType: 'json',
      success: (response) => {
        $(event.target).find(".spinner-border").hide();
        $(`#step${step}`).html(response)
      },
      error: (response) => {
        $(event.target).attr("disabled", false);
        $(event.target).find(".spinner-border").hide();
        $(`#step${step}`).html(response)
      }
    })

  }

  initiateSync(event) {
    let id = $(event.target).data('id');
    let actor_set_id = $(event.target).data('actor-set-id');
    $(event.target).attr("disabled", true);

    Rails.ajax({
      type: 'POST',
      url: `/actor_sets/${actor_set_id}/airtable_base/start_sync`,
      dataType: 'json',
      success: (response) => {
        alert("Sync Task Started!")
      }
    })
  }

  removeFollowingSteps(step) {
    while (step <= 4) {
      $(`#step${step}`).html("")
      step += 1
    }
  }  

  fieldChanged(event) {
    let container_id = $(event.target).data('container');

    if ($(event.target).attr("id") == "base_id") {
      $("#base_name").val($(event.target).find("option:selected").text())
    }
    
    $(container_id).find("button").attr("disabled", false);
    $("button[type='submit']").attr("disabled", true);
  }
}